<template>
  <div class="k12-action-footer">
    <div class="k12-action-footer-inner">
      <div class="footer-total">
        <span>{{ $t('preInvoiceV2.totalAmount') }}</span>
        <strong>{{ formattedTotal }}</strong>
      </div>
      <div class="footer-actions">
        <a-checkbox v-model="model.preview_pdf">
          {{ $t('preInvoiceV2.previewPdf') }}
        </a-checkbox>
        <a-button class="footer-btn-cancel" icon="close" @click="$emit('cancel')">{{ $t('preInvoiceV2.cancel') }}</a-button>
        <a-button v-if="!isEdit" class="footer-btn-clear" icon="reload" @click="$emit('reset')">{{ $t('preInvoiceV2.clear') }}</a-button>
        <a-button
          v-if="showPayByQr"
          class="footer-btn-pay-qr"
          icon="qrcode"
          :loading="qrBusy"
          :disabled="isActionDisabled || qrDisabled"
          @click="$emit('pay-by-qr')"
        >
          {{ $t('preInvoiceV2.payByQr') }}
        </a-button>
        <a-button v-if="!isEdit && showSaveAndAddNew" class="footer-btn-add-new" icon="plus" :loading="savingAction === 'addNew'" :disabled="isSaveDisabled" @click="$emit('save', true)">
          {{ $t('preInvoiceV2.saveAndAddNew') }}
        </a-button>
        <a-button class="footer-btn-save" type="primary" icon="save" :loading="savingAction === 'save'" :disabled="isSaveDisabled" @click="$emit('save', false)">
          {{ isEdit ? $t('preInvoiceV2.update') : $t('preInvoiceV2.save') }}
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionFooter',
  props: {
    model: { type: Object, required: true },
    formattedTotal: { type: String, required: true },
    saving: { type: Boolean, required: true },
    savingAction: { type: String, default: null },
    isEdit: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    showPayByQr: { type: Boolean, default: false },
    qrBusy: { type: Boolean, default: false },
    qrDisabled: { type: Boolean, default: false },
    showSaveAndAddNew: { type: Boolean, default: true },
    saveDisabled: { type: Boolean, default: false }
  },
  computed: {
    isActionDisabled() {
      return this.saving || this.busy
    },
    isSaveDisabled() {
      return this.isActionDisabled || this.saveDisabled
    }
  }
}
</script>

<style>
.k12-action-footer {
  position: fixed;
  left: 220px;
  right: 0;
  bottom: 0;
  z-index: 1010;
  width: auto;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.10);
}

.page-sidebar-minified .k12-action-footer {
  left: 60px;
}

.page-with-wide-sidebar:not(.page-sidebar-minified) .k12-action-footer {
  left: 250px;
}

.page-without-sidebar .k12-action-footer,
.page-with-right-sidebar .k12-action-footer {
  left: 0;
}

.k12-action-footer-inner {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.footer-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.footer-btn-cancel {
  color: #4b5563;
  border-color: #d1d5db;
  background: #ffffff;
}

.footer-btn-cancel:hover,
.footer-btn-cancel:focus {
  color: #1f2937;
  border-color: #9ca3af;
  background: #f9fafb;
}

.footer-btn-clear {
  color: #b45309;
  border-color: #f59e0b;
  background: #fffbeb;
}

.footer-btn-clear:hover,
.footer-btn-clear:focus {
  color: #92400e;
  border-color: #d97706;
  background: #fef3c7;
}

.footer-btn-pay-qr {
  color: #047857;
  border-color: #10b981;
  background: #ecfdf5;
}

.footer-btn-pay-qr:hover,
.footer-btn-pay-qr:focus {
  color: #065f46;
  border-color: #059669;
  background: #d1fae5;
}

.footer-btn-add-new {
  color: #2563eb;
  border-color: #2563eb;
  background: #ffffff;
}

.footer-btn-add-new:hover,
.footer-btn-add-new:focus {
  color: #1d4ed8;
  border-color: #1d4ed8;
  background: #eff6ff;
}

.footer-btn-save {
  border-color: #2563eb;
  background: #2563eb;
}

.footer-btn-save:hover,
.footer-btn-save:focus {
  border-color: #1d4ed8;
  background: #1d4ed8;
}

.footer-total {
  display: flex;
  flex-direction: column;
  color: #1f2937;
}

.footer-total span {
  font-size: 12px;
  font-weight: 600;
}

.footer-total strong {
  font-size: 18px;
  font-weight: 800;
}

@media (max-width: 767px) {
  .k12-action-footer {
    left: 0;
  }
}

@media (max-width: 640px) {
  .k12-action-footer-inner {
    align-items: stretch;
    flex-direction: column;
  }

  .footer-actions {
    justify-content: stretch;
  }

  .footer-actions .ant-btn {
    flex: 1 1 auto;
  }
}
</style>
